// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_ma7","image":"Header_image__16V99","name":"Header_name__q8T_a","info":"Header_info__1p1_u","infoRow":"Header_infoRow__1zsbd"};